module.exports = __webpack_public_path__ + "static/57invgde-bd7d49bdb211386554b0e244c48a12db.gif";